import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import { printStockVoucher } from './printStockVoucher';
import mohLogo from '../../assets/moh-logo.png';

export default {
    name: 'StockVouchers',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },
    watch: {
        '$route.query.id'(value) {
            const id = Number(value);
            if (id) {
                this.openDetail({ id });
                return;
            }

            this.detailDialog = false;
        }
    },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewStockVouchersUi()) {
            this.logout();
            return;
        }
        this.GetInfo();
        if (this.$route && this.$route.query && this.$route.query.id) {
            this.openDetail({ id: Number(this.$route.query.id) });
        }
    },

    computed: {
        isMinistryAdmin() {
            return this.loginDetails && !this.isFacilityCenterRole();
        },
        canCreateDepartmentIssue() {
            return this.isFacilityCenterRole() && this.canIssueToFacilityDepartmentsUi();
        },
        statsCards() {
            return [
                this.statCard('إجمالي السندات', this.pages, 'primary', 'ti ti-files'),
                this.statCard('إجمالي الكمية الحالية', this.sumWhere(this.Info, item => item.totalQty), 'info', 'ti ti-box-multiple'),
                this.statCard('سندات صرف', this.countWhere(this.Info, item => String(item.voucherTypeLabel || '').includes('صرف')), 'warning', 'ti ti-arrow-up-right'),
                this.statCard('سندات إدخال', this.countWhere(this.Info, item => String(item.voucherTypeLabel || '').includes('إدخال')), 'success', 'ti ti-arrow-down-left'),
            ];
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            voucherType: 0,
            Info: [],
            detail: null,
            detailDialog: false,
            createDialog: false,
            departments: [],
            sourceStockings: [],
            products: [],
            issueForm: {
                facilityDepartmentId: '',
                sourceStockingId: '',
                note: '',
                lines: []
            }
        };
    },

    methods: {
        formatStatValue(value) {
            return new Intl.NumberFormat('en-US').format(Number(value || 0));
        },
        statSubtitle(title) {
            if (title === 'إجمالي السندات') return 'إجمالي السجلات المتاحة وفق عوامل التصفية الحالية';
            if (title === 'إجمالي الكمية الحالية') return 'مجموع الكميات الظاهرة في الصفحة الحالية';
            if (title === 'سندات صرف') return 'سندات الصرف والمتابعة الداخلية للمخازن';
            if (title === 'سندات إدخال') return 'سندات الإدخال والاستلام المعتمدة بالنظام';
            return 'ملخص سريع لحالة السندات';
        },
        voucherMetaText(item) {
            if (!item) return '-';
            const parts = [];
            if (item.referenceCode) parts.push(`المرجع: ${item.referenceCode}`);
            else if (item.sourceEntityType) parts.push(item.sourceEntityType);
            parts.push(`الكمية: ${Number(item.totalQty || 0)}`);
            return parts.join(' | ');
        },
        locationPrimaryText(item) {
            if (!item) return '-';
            if (this.isMinistryAdmin) return item.branchName || '-';
            return item.departmentName || item.branchName || '-';
        },
        locationSecondaryText(item) {
            if (!item) return 'بدون جهة فرعية';
            if (this.isMinistryAdmin) return item.departmentName || item.stockingName || 'بدون قسم محدد';
            return item.stockingName || item.referenceCode || 'بدون مخزن محدد';
        },
        voucherTone(item) {
            const label = String(item && item.voucherTypeLabel ? item.voucherTypeLabel : '').toLowerCase();
            if (label.includes('إدخال')) return 'success';
            if (label.includes('إرجاع')) return 'info';
            if (label.includes('إعدام')) return 'danger';
            if (label.includes('تدوير')) return 'warning';
            if (label.includes('زيادة')) return 'success';
            if (label.includes('عجز')) return 'danger';
            return 'primary';
        },
        voucherIcon(item) {
            const label = String(item && item.voucherTypeLabel ? item.voucherTypeLabel : '');
            if (label.includes('إدخال')) return 'ti ti-arrow-down-left';
            if (label.includes('إرجاع')) return 'ti ti-arrow-back-up';
            if (label.includes('إعدام')) return 'ti ti-trash';
            if (label.includes('تدوير')) return 'ti ti-refresh';
            if (label.includes('زيادة')) return 'ti ti-plus';
            if (label.includes('عجز')) return 'ti ti-minus';
            return 'ti ti-arrow-up-right';
        },
        typeHintText(item) {
            if (!item) return '-';
            if (item.referenceCode) return `مرجع السند: ${item.referenceCode}`;
            if (item.sourceEntityType) return `مصدر الحركة: ${item.sourceEntityType}`;
            return 'سند رسمي بدون مرجع إضافي';
        },
        statusBadgeClass(status, label) {
            const normalizedStatus = Number(status);
            const normalizedLabel = String(label || '').toLowerCase();
            if (normalizedStatus === 3 || normalizedLabel.includes('معتمد') || normalizedLabel.includes('مكتمل') || normalizedLabel.includes('منفذ')) return 'bg-label-success';
            if (normalizedStatus === 4 || normalizedLabel.includes('مرفوض') || normalizedLabel.includes('ملغي')) return 'bg-label-danger';
            if (normalizedStatus === 2 || normalizedLabel.includes('مرسل') || normalizedLabel.includes('قيد') || normalizedLabel.includes('بانتظار')) return 'bg-label-warning';
            return 'bg-label-primary';
        },
        statusHintText(item) {
            if (!item) return '-';
            if (item.printedOn) return `آخر طباعة ${this.moment(item.printedOn)}`;
            if (item.referenceCode) return `مرتبطة بالمرجع ${item.referenceCode}`;
            return 'جاهز لعرض التفاصيل والطباعة الرسمية';
        },
        loadIssueMetadata() {
            if (!this.canCreateDepartmentIssue) return Promise.resolve();
            return Promise.all([
                this.$http.GetAllFacilityDepartments(),
                this.$http.GetAllStocking()
            ]).then(([departmentsRes, stockingRes]) => {
                this.departments = departmentsRes.data.info || [];
                this.sourceStockings = (stockingRes.data.info || []).filter((x) => !x.facilityDepartmentId);
                this.products = [];
            });
        },
        onSourceStockingChanged() {
            this.loadIssueProductsByStocking();
        },
        loadIssueProductsByStocking() {
            const sourceStockingId = Number(this.issueForm.sourceStockingId || 0);
            if (!sourceStockingId) {
                this.products = [];
                this.syncIssueLinesWithAvailableProducts();
                return Promise.resolve();
            }
            return this.$http.GetDepartmentIssueProducts(sourceStockingId)
                .then((response) => {
                    this.products = response.data.info || [];
                    this.syncIssueLinesWithAvailableProducts();
                })
                .catch(() => {
                    this.products = [];
                    this.syncIssueLinesWithAvailableProducts();
                });
        },
        syncIssueLinesWithAvailableProducts() {
            const availableIds = new Set((this.products || []).map((x) => Number(x.id)));
            (this.issueForm.lines || []).forEach((line) => {
                if (Number(line.productsId || 0) > 0 && !availableIds.has(Number(line.productsId))) {
                    line.productsId = '';
                }
            });
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetStockVouchers(this.pageNo, this.pageSize, this.Search, this.voucherType)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },
        openDetail(item) {
            const id = item && item.id ? item.id : null;
            if (!id) return;
            this.$blockUI.Start();
            this.$http.GetStockVoucher(id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.detail = response.data.info;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        openCreateDialog() {
            this.issueForm = {
                facilityDepartmentId: '',
                sourceStockingId: '',
                note: '',
                lines: [{ productsId: '', quantity: 1, note: '' }]
            };
            this.createDialog = true;
            this.loadIssueMetadata();
        },
        addIssueLine() {
            if (!this.issueForm.sourceStockingId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار مخزن الصرف أولاً.');
                return;
            }
            this.issueForm.lines.push({ productsId: '', quantity: 1, note: '' });
        },
        removeIssueLine(index) {
            if (this.issueForm.lines.length <= 1) return;
            this.issueForm.lines.splice(index, 1);
        },
        submitDepartmentIssue() {
            const body = {
                facilityDepartmentId: Number(this.issueForm.facilityDepartmentId || 0),
                sourceStockingId: Number(this.issueForm.sourceStockingId || 0),
                note: this.issueForm.note || '',
                lines: (this.issueForm.lines || [])
                    .filter((x) => Number(x.productsId) > 0 && Number(x.quantity) > 0)
                    .map((x) => ({
                        productsId: Number(x.productsId),
                        quantity: Number(x.quantity),
                        note: x.note || ''
                    }))
            };
            if (!body.facilityDepartmentId || !body.sourceStockingId || body.lines.length === 0) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى استكمال بيانات الصرف الداخلي.');
                return;
            }
            this.$blockUI.Start();
            this.$http.CreateDepartmentIssueVoucher(body)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.createDialog = false;
                    this.GetInfo(1);
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data.message || 'تم إنشاء سند الصرف الداخلي.');
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تنفيذ الصرف الداخلي.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        decisionBadgeClass(decision) {
            if (decision === 2) return 'bg-label-success';
            if (decision === 3) return 'bg-label-danger';
            return 'bg-label-warning';
        },
        printDetail() {
            if (!this.detail || !this.detail.id || !this.detail.canPrint) return;
            this.$http.MarkStockVoucherPrinted(this.detail.id)
                .then(() => {
                    const opened = printStockVoucher(this.detail, {
                        buildFor: 'وزارة الصحة',
                        logoUrl: mohLogo
                    });
                    if (!opened) {
                        this.$helper.ShowMessage('warning', 'تنبيه', 'تعذر فتح نافذة الطباعة. تحقق من مانع النوافذ.');
                        return;
                    }
                    this.$http.GetStockVoucher(this.detail.id).then((response) => {
                        this.detail = response.data.info;
                        this.GetInfo(this.pageNo);
                    });
                })
                .catch((err) => {
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تسجيل الطباعة.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        }
    }
};
